<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <toggleswitch
            :labels="true"
            name="client_at_fault"
            label="Client at Fault?"
            v-model="details.client_at_fault"
          ></toggleswitch>

          <selectlist
            :options="categories"
            v-model="details.category_id"
            label="Incident Category"
            name="incident_type"
            label-name="name"
          ></selectlist>

          <input-block
            v-model="details.description"
            name="details"
            label="Accident Details"
          ></input-block>

          <input-block
            v-model="details.further_details"
            name="further_details"
            label="Any Further Details"
          ></input-block>

          <fieldset>
            <legend>
              Journey Details
              <small class="text-muted">
                - Enter the journey route and what the vehicle was being used
                for here
              </small>
            </legend>

            <journey-details
              ref="journeyDetails"
              v-on:set-reason="setReason"
              v-on:set-route="setJourney"
            ></journey-details>
          </fieldset>

          <fieldset>
            <legend>
              Accident Location
              <small class="text-muted"
                >- Enter where the accident occurred here</small
              >
            </legend>

            <accident-location
              v-on:located="setLocation"
              :location="details.location"
              :lat="details.latitude"
              :lng="details.longitude"
            ></accident-location>
          </fieldset>

          <fieldset>
            <legend>
              Damage Details
              <small class="text-muted">- Enter the damage </small>
            </legend>
            <photo-upload :incident="incident"> </photo-upload>

            <div class="row">
              <div class="col-md-4">
                <div class="damage-key">
                  <div class="colour severe"></div>
                  <div class="damage-label">Severe</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="damage-key">
                  <div class="colour major"></div>
                  <div class="damage-label">Major</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="damage-key">
                  <div class="colour minor"></div>
                  <div class="damage-label">Minor</div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <left-vehicle
                v-on:updated="updateLeftDamage"
                :front="car.left_front"
                :frontDoor="car.left_front_door"
                :rearDoor="car.left_rear_door"
                :rear="car.left_rear"
                :frontWheel="car.left_front_wheel"
                :rearWheel="car.left_rear_wheel"
              ></left-vehicle>
            </div>
            <div class="row">
              <div class="col-12 main-images">
                <div class="col-lg-4 col-lg-push-4 text-center roof">
                  <vehicle-roof
                    v-on:updated="updateRoofDamage"
                    :rearWindscreen="car.rear_windscreen"
                    :roof="car.roof"
                    :frontWindscreen="car.front_windscreen"
                    :bonnet="car.top_bonnet"
                  ></vehicle-roof>
                </div>
                <div class="col-lg-4 col-lg-pull-4 col-md-6 text-center rear">
                  <rear-vehicle
                    v-on:updated="updateRearDamage"
                    :bumper="car.rear_bumper"
                    :boot="car.rear_boot"
                  ></rear-vehicle>
                </div>
                <div class="col-lg-4 col-md-6 text-center front">
                  <front-vehicle
                    v-on:updated="updateFrontDamage"
                    :bumper="car.front_bumper"
                    :bonnet="car.front_bonnet"
                  ></front-vehicle>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <right-vehicle
                v-on:updated="updateRightDamage"
                :front="car.right_front"
                :frontDoor="car.right_front_door"
                :rearDoor="car.right_rear_door"
                :rear="car.right_rear"
                :frontWheel="car.right_front_wheel"
                :rearWheel="car.right_rear_wheel"
              ></right-vehicle>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-primary btn-raised">
        <i class="icon icon-save"></i> Save
      </button>
    </div>
  </form>
</template>
<script>
import AccidentLocation from './Children/AccidentLocation.vue';
import Rear from './Children/Car/Rear.vue';
import Roof from './Children/Car/Roof.vue';
import Front from './Children/Car/Front.vue';
import Left from './Children/Car/Left.vue';
import Right from './Children/Car/Right.vue';
// import JourneyDetails from './Children/JourneyDetails.vue';
import PhotoUpload from '../../FirstNoticeOfLoss/Sections/Children/PhotoUpload.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    'accident-location': AccidentLocation,
    'rear-vehicle': Rear,
    'vehicle-roof': Roof,
    'front-vehicle': Front,
    'left-vehicle': Left,
    'right-vehicle': Right,
    // 'journey-details': JourneyDetails,
    'photo-upload': PhotoUpload
  },

  data() {
    return {
      categories: [],
      journey: new window.Form({
        start_location: '',
        start_latitude: '',
        start_longitude: '',
        end_location: '',
        end_latitude: '',
        end_longitude: '',
        reason: ''
      }),
      details: new window.Form(
        {
          client_at_fault: false,
          category_id: null,
          description: null,
          latitude: null,
          longitude: null,
          location: null,
          pitch: null,
          heading: null,
          further_details: null
        },
        false
      ),
      car: new window.Form({
        rear_bumper: 0,
        rear_boot: 0,
        rear_windscreen: 0,
        roof: 0,
        front_windscreen: 0,
        top_bonnet: 0,
        front_bumper: 0,
        front_bonnet: 0,
        left_front_door: 0,
        left_front: 0,
        left_rear_door: 0,
        left_rear: 0,
        left_rear_wheel: 0,
        left_front_wheel: 0,
        right_front_door: 0,
        right_front: 0,
        right_rear_door: 0,
        right_rear: 0,
        right_front_wheel: 0,
        right_rear_wheel: 0
      }),
      client: null,
      vehicle: null,
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      window.Ajax.get('/incident-categories')
        .then(response => {
          this.categories = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/incidents/' + this.incident + '/details')
        .then(response => {
          this.setDetails(response.data);
        })
        .catch(error => {});

      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data.identifier;

          window.Ajax.get(
            '/incidents/' +
              this.incident +
              '/client/' +
              this.client +
              '/vehicle'
          )
            .then(response => {
              this.vehicle = response.data.identifier;

              window.Ajax.get(
                '/incidents/' +
                  this.incident +
                  '/client/' +
                  this.client +
                  '/vehicle/' +
                  this.vehicle +
                  '/journey'
              )
                .then(response => {
                  this.$refs.journeyDetails.getJourney(response.data);
                })
                .catch(error => {});

              window.Ajax.get(
                '/incidents/' +
                  this.incident +
                  '/client/' +
                  this.client +
                  '/vehicle/' +
                  this.vehicle +
                  '/damage'
              )
                .then(response => {
                  this.updateCar(response.data);
                })
                .catch(error => {});
            })
            .catch(error => {});
        })
        .catch(error => {});
    },

    updateFrontDamage(value) {
      let refined = {
        front_bumper: value.bumper,
        front_bonnet: value.bonnet
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRightDamage(value) {
      let refined = {
        right_front_door: value.frontDoor,
        right_front: value.frontBumper,
        right_rear_door: value.backDoor,
        right_rear: value.rearBumper,
        right_front_wheel: value.frontWheel,
        right_rear_wheel: value.rearWheel
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateLeftDamage(value) {
      let refined = {
        left_front_door: value.frontDoor,
        left_front: value.frontBumper,
        left_rear_door: value.backDoor,
        left_rear: value.rearBumper,
        left_front_wheel: value.frontWheel,
        left_rear_wheel: value.rearWheel
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRoofDamage(value) {
      let refined = {
        rear_windscreen: value.rearWindscreen,
        roof: value.roof,
        front_windscreen: value.frontWindscreen,
        top_bonnet: value.bonnet
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRearDamage(value) {
      let refined = {
        rear_bumper: value.bumper,
        rear_boot: value.boot
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateCar(data) {
      for (let property in data) {
        if (this.car[property]) {
          this.car[property] = data[property];
        }
      }
    },

    setDetails(data) {
      this.details.category_id = data.category_id;
      this.details.description = data.description;
      this.details.client_at_fault = data.client_at_fault;
      this.details.latitude = data.latitude;
      this.details.longitude = data.longitude;
      this.details.location = data.location;
      this.details.pitch = data.pitch;
      this.details.heading = data.heading;
      this.details.further_details = data.further_details;
    },

    setJourney(data) {
      this.journey.start_location = data.start_location;
      this.journey.start_latitude = data.start_latitude;
      this.journey.start_longitude = data.start_longitude;
      this.journey.end_location = data.end_location;
      this.journey.end_latitude = data.end_latitude;
      this.journey.end_longitude = data.end_longitude;
      this.journey.reason = data.reason;
    },

    setReason(reason) {
      this.journey.reason = reason;
    },

    setLocation(data) {
      this.details.latitude = data.map.latitude;
      this.details.longitude = data.map.longitude;
      this.details.location = data.location;
      this.details.pitch = data.map.pitch;
      this.details.heading = data.map.heading;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      window.toastify.info('Saving', "We're saving those details for you.");

      this.details
        .post('/incidents/' + this.incident + '/details')
        .then(response => {
          this.journey
            .put(
              '/incidents/' +
                this.incident +
                '/client/' +
                this.client +
                '/vehicle/' +
                this.vehicle +
                '/journey'
            )
            .then(response => {
              this.car
                .post(
                  '/incidents/' +
                    this.incident +
                    '/client/' +
                    this.client +
                    '/vehicle/' +
                    this.vehicle +
                    '/damage'
                )
                .then(response => {
                  window.toastify.success(
                    'Saved',
                    "We've updated those details for you."
                  );
                  // reset monitoring of form changes
                  this.data_entered = false;
                  this.$emit('unsaved-data', this.data_entered);
                })
                .catch(error => {
                  window.toastify.error(
                    'Error',
                    'Sorry, there was an error when saving the accident details.'
                  );
                });
            })
            .catch(error => {
              window.toastify.error(
                'Error',
                'Sorry, there was an error when saving the accident details.'
              );
            });
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error when saving the accident details.'
          );
        });
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
